var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',_vm._b({attrs:{"icon":"el-icon-download","loading":_vm.loading,"disabled":_vm.loading},on:{"click":_vm.exportPpt}},'el-button',_vm.$attrs,false),[_vm._v(" 产品手卡 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }